/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyDescriptionExternalLink = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyDescriptionExternalLink model module.
   * @module model/StrategyDescriptionExternalLink
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyDescriptionExternalLink</code>.
   * @alias module:model/StrategyDescriptionExternalLink
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>StrategyDescriptionExternalLink</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyDescriptionExternalLink} obj Optional instance to populate.
   * @return {module:model/StrategyDescriptionExternalLink} The populated <code>StrategyDescriptionExternalLink</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('LinkTitle')) {
        obj['LinkTitle'] = ApiClient.convertToType(data['LinkTitle'], 'String');
      }
      if (data.hasOwnProperty('LinkURI')) {
        obj['LinkURI'] = ApiClient.convertToType(data['LinkURI'], 'String');
      }
      if (data.hasOwnProperty('AddedByUserID')) {
        obj['AddedByUserID'] = ApiClient.convertToType(data['AddedByUserID'], 'Integer');
      }
      if (data.hasOwnProperty('Added')) {
        obj['Added'] = ApiClient.convertToType(data['Added'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} StrategyDescriptionID
   * @default 0
   */
  exports.prototype['StrategyDescriptionID'] = 0;
  /**
   * @member {String} LinkTitle
   * @default ''
   */
  exports.prototype['LinkTitle'] = '';
  /**
   * @member {String} LinkURI
   * @default ''
   */
  exports.prototype['LinkURI'] = '';
  /**
   * @member {Integer} AddedByUserID
   * @default 0
   */
  exports.prototype['AddedByUserID'] = 0;
  /**
   * @member {Date} Added
   */
  exports.prototype['Added'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


